import {
  TableCreator,
  TableCreatorMeta,
  TableMaskType,
} from '../../core/table-creator';

export enum IndicatorType {
  VALUE = '1',
  RELATIVE_PERCENTAGE = '2',
  PERCENTAGE_POINTS = '3',
}

export interface IHistoricalProfitTable {
  yearName: string;
  nicename: string;
  benchmarkNicename: string;
  '1': number;
  '2': number;
  '3': number;
  '4': number;
  '5': number;
  '6': number;
  '7': number;
  '8': number;
  '9': number;
  '10': number;
  '11': number;
  '12': number;
  year: number;
  accrued: number;
  benchmarkStatsYear: {
    '1': number;
    '2': number;
    '3': number;
    '4': number;
    '5': number;
    '6': number;
    '7': number;
    '8': number;
    '9': number;
    '10': number;
    '11': number;
    '12': number;
    year: number;
    accrued: number;
  };
}

export const INDICATOR_TYPE_OPTIONS = [
  { label: 'Valor do indicador', value: IndicatorType.VALUE },
  {
    label: '% relativo',
    value: IndicatorType.RELATIVE_PERCENTAGE,
  },
  {
    label: 'Pontos percentuais',
    value: IndicatorType.PERCENTAGE_POINTS,
  },
];

export const getHistoricalProfitTableColumns = (mask: TableMaskType) =>
  new TableCreator<IHistoricalProfitTable>()
    .addColumn({
      key: 'yearName',
      header: 'ANO',
      size: 90,
      meta: new TableCreatorMeta().isHeader().pinned('left'),
    })
    .addColumn({
      key: 'nicename',
      header: '',
      size: 900,
      meta: new TableCreatorMeta().subLine('benchmarkNicename'),
    })
    .addColumn({
      key: '1',
      header: 'Jan',
      meta: new TableCreatorMeta()
        .mask(mask)
        .subLine('benchmarkStatsYear.1', null)
        .showNegative(),
    })
    .addColumn({
      key: '2',
      header: 'Fev',
      meta: new TableCreatorMeta()
        .mask(mask)
        .subLine('benchmarkStatsYear.2', null)
        .showNegative(),
    })
    .addColumn({
      key: '3',
      header: 'Mar',
      meta: new TableCreatorMeta()
        .mask(mask)
        .subLine('benchmarkStatsYear.3', null)
        .showNegative(),
    })
    .addColumn({
      key: '4',
      header: 'Abr',
      meta: new TableCreatorMeta()
        .mask(mask)
        .subLine('benchmarkStatsYear.4', null)
        .showNegative(),
    })
    .addColumn({
      key: '5',
      header: 'Mai',
      meta: new TableCreatorMeta()
        .mask(mask)
        .subLine('benchmarkStatsYear.5', null)
        .showNegative(),
    })
    .addColumn({
      key: '6',
      header: 'Jun',
      meta: new TableCreatorMeta()
        .mask(mask)
        .subLine('benchmarkStatsYear.6', null)
        .showNegative(),
    })
    .addColumn({
      key: '7',
      header: 'Jul',
      meta: new TableCreatorMeta()
        .mask(mask)
        .subLine('benchmarkStatsYear.7', null)
        .showNegative(),
    })
    .addColumn({
      key: '8',
      header: 'Ago',
      meta: new TableCreatorMeta()
        .mask(mask)
        .subLine('benchmarkStatsYear.8', null)
        .showNegative(),
    })
    .addColumn({
      key: '9',
      header: 'Set',
      meta: new TableCreatorMeta()
        .mask(mask)
        .subLine('benchmarkStatsYear.9', null)
        .showNegative(),
    })
    .addColumn({
      key: '10',
      header: 'Out',
      meta: new TableCreatorMeta()
        .mask(mask)
        .subLine('benchmarkStatsYear.10', null)
        .showNegative(),
    })
    .addColumn({
      key: '11',
      header: 'Nov',
      meta: new TableCreatorMeta()
        .mask(mask)
        .subLine('benchmarkStatsYear.11', null)
        .showNegative(),
    })
    .addColumn({
      key: '12',
      header: 'Dez',
      meta: new TableCreatorMeta()
        .mask(mask)
        .subLine('benchmarkStatsYear.12', null)
        .showNegative(),
    })
    .addColumn({
      key: 'year',
      header: 'No ano',
      meta: new TableCreatorMeta()
        .mask(mask)
        .subLine('benchmarkStatsYear.year', null)
        .showNegative()
        .isHeader(),
    })
    .addColumn({
      key: 'accrued',
      header: 'Acumulado',
      meta: new TableCreatorMeta()
        .mask(mask)
        .subLine('benchmarkStatsYear.accrued', null)
        .showNegative()
        .isHeader(),
    })
    .getColumns();
